import { StyleFactory } from '../styling';

const trackColors: Partial<Record<number, string>> = {
    [0x6c]: 'rgb(152, 179, 217)',
    [0x6d]: 'rgb(223, 183, 179)',
    [0x6e]: 'rgb(152, 179, 217)',
    [0x6f]: 'rgb(223, 183, 179)'
};

const trackImages: Partial<Record<number, string>> = {
    [0x6c]: 'rect-nat',
    [0x6d]: 'rect-pat',
    [0x6e]: 'rect-nat',
    [0x6f]: 'rect-pat'
};

export const tracksLayers: StyleFactory = (baseId, _, productId) => {
    return [
        {
            id: baseId + '-line',
            source: baseId,
            pickable: true,
            type: 'line',
            paint: {
                'line-width': 3,
                'line-color': trackColors[productId] ?? 'rgb(255,255,255)'
            }
        },
        {
            type: 'symbol',
            id: baseId + '-line-label',
            minzoom: 2,
            pickable: true,
            source: baseId,
            layout: {
                'text-field': ['get', 'label'],
                'text-offset': [0, 0],
                'icon-image': ['image', trackImages[productId] ?? ''],
                'icon-text-fit': 'both',
                'icon-text-fit-padding': [0, 1, 0, 1],
                'text-allow-overlap': true,
                'icon-allow-overlap': true,
                'text-anchor': 'center',
                'text-font': ['Open Sans Regular'],
                'text-size': 12,
                'symbol-placement': 'line-center',
                'symbol-spacing': 1000,
                'symbol-avoid-edges': true
            },
            paint: {
                'text-color': 'black'
            }
        },
        {
            type: 'symbol',
            id: baseId + '-labels',
            filter: ['==', ['geometry-type'], 'Point'],
            minzoom: 3,
            source: baseId,
            layout: {
                'text-field': ['get', 'label'],
                'text-offset': [0, 0.25],
                'text-allow-overlap': true,
                'text-anchor': 'top',
                'text-font': ['Open Sans Regular'],
                'text-size': 10
            },
            paint: {
                'text-color': ['global-state', 'text-color']
            }
        }
    ];
};

export const tfrLayers: StyleFactory = (baseId) => {
    return [
        {
            id: baseId + '-fill',
            source: baseId,
            pickable: true,
            type: 'fill',
            paint: {
                'fill-pattern': ['image', 'tfr-pattern'],
                'fill-outline-color': 'rgb(255,0,0)',
                'fill-opacity': ['global-state', 'trf-transparency']
            }
        },
        {
            id: baseId + '-line',
            source: baseId,
            type: 'line',
            paint: {
                'line-width': 2,
                'line-color': 'rgb(255,0,0)'
            }
        },
        {
            type: 'fill',
            id: baseId + '-hover',
            source: baseId,
            paint: {
                // prettier-ignore
                'fill-color': [
                    'case',
                    ['boolean', ['feature-state', 'hover'], false], 'rgba(0,0,0,0.22)',
                    'rgba(0,0,0,0)'
                ]
            }
        }
    ];
};

export const raimLayers: StyleFactory = (baseId) => {
    return [
        {
            id: baseId + '-fill',
            source: baseId,
            type: 'fill',
            paint: {
                'fill-color': 'rgba(255,0,0, 0.156)'
            }
        },
        {
            id: baseId + '-line',
            source: baseId,
            type: 'line',
            paint: {
                'line-width': ['interpolate', ['linear'], ['zoom'], 0, 1, 4, 2],
                'line-color': 'rgb(255,0,0)'
            }
        },
        {
            type: 'fill',
            id: baseId + '-hover',
            source: baseId,
            paint: {
                // prettier-ignore
                'fill-color': [
                    'case',
                    ['boolean', ['feature-state', 'hover'], false], 'rgba(0,0,0,0.22)',
                    'rgba(0,0,0,0)'
                ]
            }
        }
    ];
};
